// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quote {
  display: flex;
  position: relative;
  flex-direction: row;
  background-image: url("https://ljc-site.s3.us-east-2.amazonaws.com/img/purple.jpeg");
  background-repeat: no-repeat;
  background-position: center;
  background-attachment: fixed;
  background-size: cover;
  width: 100%;
  opacity: 0;
  animation: FadeIn 1s 8s ease-in-out forwards;
}
.quote_container {
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 20px;
  height: 400px;
  justify-content: center;
  animation: fadeIn 1s 8s ease-in-out forwards;
}
.quote_chevron-left {
  height: 40px;
  width: 40px;
  position: absolute;
  top: 45%;
  z-index: 2;
  cursor: pointer;
  filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.9));
  left: 5%;
}
@media (max-width: 768px) {
  .quote_chevron-left {
    left: 2%;
  }
}
.quote_chevron-right {
  height: 40px;
  width: 40px;
  color: white;
  position: absolute;
  top: 45%;
  z-index: 2;
  cursor: pointer;
  filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.9));
  right: 5%;
}
@media (max-width: 768px) {
  .quote_chevron-right {
    right: 2%;
  }
}

@keyframes FadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@media screen and (max-width: 1680px) {
  .quote-container {
    height: 300px;
  }
}
.extra-space {
  width: 800px;
  height: 500px;
  background-color: black;
}

.service-overlay {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(29, 53, 87, 0.8);
  width: 100%;
  height: 100vh;
}

.card-service-title {
  display: flex;
  flex-direction: column;
  font-family: "Spartan", sans-serif;
  color: #a5e300;
  font-size: 50px;
  justify-content: center;
  align-items: center;
  padding: 50px;
  letter-spacing: 20px;
  opacity: 0;
  animation: fadeIn 1s 8s ease-in-out forwards;
}

.card-grid {
  display: flex;
  flex-direction: row;
  position: relative;
  flex-wrap: wrap;
}

img {
  width: 100%;
  height: 100%;
}

.card-grid-1 {
  height: 400px;
  width: 500px;
  margin: 10px;
}

.card-grid-2 {
  height: 400px;
  width: 500px;
  margin: 10px;
}

.card-grid-3 {
  height: 400px;
  width: 500px;
  margin: 10px;
}

.card-grid-4 {
  height: 400px;
  width: 500px;
  margin: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/Quote-Section/Quote.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,oFAAA;EACA,4BAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;EACA,WAAA;EACA,UAAA;EACA,4CAAA;AADF;AAGE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,4CAAA;AADJ;AAIE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,mDAAA;EACA,QAAA;AAFJ;AAGI;EATF;IAUI,QAAA;EAAJ;AACF;AAGE;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,mDAAA;EACA,SAAA;AADJ;AAEI;EAVF;IAWI,SAAA;EACJ;AACF;;AAGA;EACE;IACE,UAAA;EAAF;EAEA;IACE,UAAA;EAAF;AACF;AAGA;EACE;IACE,aAAA;EADF;AACF;AAIA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,uCAAA;EACA,WAAA;EACA,aAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,kCAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,oBAAA;EACA,UAAA;EACA,4CAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;AAFF;;AAKA;EACE,aAAA;EACA,YAAA;EACA,YAAA;AAFF;;AAIA;EACE,aAAA;EACA,YAAA;EACA,YAAA;AADF;;AAGA;EACE,aAAA;EACA,YAAA;EACA,YAAA;AAAF;;AAEA;EACE,aAAA;EACA,YAAA;EACA,YAAA;AACF","sourcesContent":["@use \"../../shared/shared.scss\" as ljc;\n\n.quote {\n  display: flex;\n  position: relative;\n  flex-direction: row;\n  background-image: url(\"https://ljc-site.s3.us-east-2.amazonaws.com/img/purple.jpeg\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-attachment: fixed;\n  background-size: cover;\n  width: 100%;\n  opacity: 0;\n  animation: FadeIn 1s 8s ease-in-out forwards;\n\n  &_container {\n    display: flex;\n    flex-direction: column;\n    margin: auto;\n    padding: 20px;\n    height: 400px;\n    justify-content: center;\n    animation: fadeIn 1s 8s ease-in-out forwards;\n  }\n\n  &_chevron-left {\n    height: 40px;\n    width: 40px;\n    position: absolute;\n    top: 45%;\n    z-index: 2;\n    cursor: pointer;\n    filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.9));\n    left: 5%;\n    @media (max-width: ljc.$mobile76) {\n      left: 2%;\n    }\n  }\n\n  &_chevron-right {\n    height: 40px;\n    width: 40px;\n    color: white;\n    position: absolute;\n    top: 45%;\n    z-index: 2;\n    cursor: pointer;\n    filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.9));\n    right: 5%;\n    @media (max-width: ljc.$mobile76) {\n      right: 2%;\n    }\n  }\n}\n\n@keyframes FadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@media screen and (max-width: 1680px) {\n  .quote-container {\n    height: 300px;\n  }\n}\n\n.extra-space {\n  width: 800px;\n  height: 500px;\n  background-color: black;\n}\n\n.service-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: rgba(29, 53, 87, 0.8);\n  width: 100%;\n  height: 100vh;\n}\n\n.card-service-title {\n  display: flex;\n  flex-direction: column;\n  font-family: \"Spartan\", sans-serif;\n  color: #a5e300;\n  font-size: 50px;\n  justify-content: center;\n  align-items: center;\n  padding: 50px;\n  letter-spacing: 20px;\n  opacity: 0;\n  animation: fadeIn 1s 8s ease-in-out forwards;\n}\n\n.card-grid {\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  flex-wrap: wrap;\n}\n\nimg {\n  width: 100%;\n  height: 100%;\n}\n\n.card-grid-1 {\n  height: 400px;\n  width: 500px;\n  margin: 10px;\n}\n.card-grid-2 {\n  height: 400px;\n  width: 500px;\n  margin: 10px;\n}\n.card-grid-3 {\n  height: 400px;\n  width: 500px;\n  margin: 10px;\n}\n.card-grid-4 {\n  height: 400px;\n  width: 500px;\n  margin: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
